<template>
  <SpFinder
    id="1"
    ref="finder"
    :show-tool-bar="false"
    :no-selection="true"
    class="channelCode"
    :url="{
      data: requestUrl + '/customer/welcome-msg/get-list'
    }"
    title="数据"
    :columns="columns"
    :actions="actions"
  />
</template>

<script>
export default {
  data () {
    const columns = [
      {
        name: '消息内容', // 表头
        key: 'text_msg' // 匹配data key
      },
      {
        name: '创建时间', // 表头
        key: 'created_at', // 匹配data key
        width: 180
      },
      {
        name: '更新时间', // 表头
        key: 'updated_at', // 匹配data key
        width: 180
      },
      {
        name: '导购', // 表头
        key: 'columnSchemaId', // 匹配data key
        width: 200,
        render: (h, { row }) => {
          let list = row.salesperson.list ? row.salesperson.list.slice(0, 1) : []
          if (list && list.length > 0) {
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                }
              },
              [
                h(
                  'ul',
                  list.map((item, index) => {
                    return h(
                      'span',
                      {
                        domProps: {
                          className: 'el-tag el-tag--info el-tag--light'
                        },
                        style: {
                          marginRight: '5px'
                        }
                      },
                      [
                        h('i', {
                          domProps: {
                            className: 'el-icon-user-solid'
                          },
                          style: {
                            color: '#409EFF',
                            marginRight: '2px'
                          }
                        }),
                        item.salesperson_name
                      ]
                    )
                  })
                ),
                h(
                  'span',
                  {},
                  row.salesperson.total_count > 1 ? '共' + row.salesperson.total_count + '人' : ''
                )
              ]
            )
          } else {
            return null
          }
        }
      },
      {
        name: '客户类型', // 表头
        key: 'target', // 匹配data key
        width: 180,
        render: (h, { row }) => {
          console.log(row)
          if (row.target === 1) {
            return h('span', {}, '会员')
          } else if (row.target === 2) {
            return h('span', {}, '非会员')
          }
        }
      }
    ]

    const actions = [
      {
        name: '新建欢迎语',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'link',
          path: '/customerConversion/welcomeLanguage/0'
        }
      },
      {
        name: '编辑',
        key: 'edit',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/customerConversion/welcomeLanguage/${row.id}` // 方法方式跳转
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          path: '/customer/welcome-msg/delete/${id}', // api url
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API
    }
  },

  methods: {}
}
</script>
<style lang="scss">
.channelcode-hover-pic {
  .hover-img {
    display: block;
    width: 150px;
    height: 150px;
  }
}
.channel-list-first {
  .channel-list-code {
    width: 60px;
    height: 60px;
  }
}
</style>
